import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import Tooltip from 'Pods/Shared/Tooltip'
import Icon from 'Pods/Shared/Icon/Icon'
import InputFieldWithPrefix from 'Pods/Shared/InputFieldWithPrefix'
import TextareaField from 'Pods/Shared/TextareaField'

function PricingAndLicenseSection({
  isFree,
  price,
  license = null,
  customLicense,
  handleInputChange,
  onFreeModelTrigger,
  onLicenseChange,
  errorFor,
  showErrors,
}) {
  return (
    <div className="section__pricing-and-license">
      <div className="modal-section__title">
        Pricing and license
        <Tooltip
          id="license-tooltip"
          content={I18n.translate('tooltips.publisher.license_html')}
          tooltipClassName="tooltip--is-list tooltip--licenses"
          className="u-inline-block"
          html
        >
          <Icon type={['fas', 'info-circle']} color="grey" className="ml-5" />
        </Tooltip>
      </div>
      <div className="row">
        <div className="col-12 col-sm-5 col-md-4 section__pricing">
          <InputFieldWithPrefix
            label="Price"
            id="price"
            name="price"
            type="number"
            step="0.01"
            prefix="$"
            simpleError
            disabled={isFree}
            errorText={errorFor('price')}
            showError={showErrors}
            value={price}
            formClassName="form-group-grey"
            inputClassName="form-control-grey"
            onChange={handleInputChange}
          />

          <div className="pricing-section__free-check">
            <input
              type="checkbox"
              id="free-model"
              className="checkbox"
              checked={isFree}
              onChange={onFreeModelTrigger}
            />
            <label htmlFor="free-model">Share for free</label>
          </div>

          <span className="separator" />
        </div>

        <div className="col-12 col-sm-5 col-md-4">
          <div className="form-group form-group-grey">
            <label>License</label>
            <Select
              className="Select-outline"
              id="license-select"
              placeholder="Choose license"
              options={[{ label: 'Choose license', value: null }].concat(I18n.translate('publisher.licenses_paid'))}
              onChange={onLicenseChange}
              value={license}
              searchable={false}
              clearable={false}
            />
          </div>
        </div>

        {license === 'custom'
          && (
          <div className="col-12 custom-license-section">
            <TextareaField
              label="Custom license"
              id="customLicense"
              name="custom_license"
              rows={5}
              errorText={errorFor('customLicense')}
              showError={showErrors}
              value={customLicense}
              formClassName="form-group-grey"
              inputClassName="form-control-grey"
              onChange={handleInputChange}
            />
          </div>
          )
        }
      </div>
    </div>
  )
}

PricingAndLicenseSection.propTypes = {
  isFree: PropTypes.bool.isRequired,
  price: PropTypes.number,
  license: PropTypes.string,
  customLicense: PropTypes.string.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  onFreeModelTrigger: PropTypes.func.isRequired,
  onLicenseChange: PropTypes.func.isRequired,
  errorFor: PropTypes.func.isRequired,
  showErrors: PropTypes.bool.isRequired,
}

export default PricingAndLicenseSection
